export const calcOpacity = (maxVisibleScrolledValue: number, scrolledValue: number, scrollOpacityStart = 0) => {
  if (scrolledValue <= scrollOpacityStart) {
    return 1;
  }

  if (scrolledValue >= maxVisibleScrolledValue) {
    return 0;
  }

  return 1 - (scrolledValue - scrollOpacityStart) / (maxVisibleScrolledValue - scrollOpacityStart);
};
